var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCameraSuccess = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11663 14.6698C8.28793 14.8762 8.54488 15 8.80183 15C8.80183 15 8.80183 15 8.84466 15C9.10161 15 9.35856 14.9175 9.52986 14.7111L13.7268 10.584C14.1122 10.2126 14.0694 9.63477 13.7268 9.26333C13.3413 8.89189 12.7418 8.93316 12.3563 9.26333L8.88748 12.6888L7.68837 11.3682C7.34577 10.9967 6.74621 10.9554 6.31796 11.2856C5.93253 11.6158 5.88971 12.1936 6.23231 12.6063L8.11663 14.6698Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10L22 7V17L18 14",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 4.5,
    width: 15,
    height: 15,
    rx: 1.5,
    stroke: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCameraSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CameraSuccess.bd6ed86a.svg";
export { ForwardRef as ReactComponent };